import { useState } from 'react';
import {
  FaBriefcaseMedical, FaBone, FaEye, FaTooth,
  FaStethoscope, FaSyringe, FaCut, FaHeartbeat,
} from 'react-icons/fa';
import SectionTitle from './ui/SectionTitle';
import ProductCard from './ui/ProductCard';
import Button from './ui/Button';
import './Products.css';

const CATEGORIES = ['All', 'General Surgery', 'Orthopedic', 'Dental', 'Ophthalmology', 'ENT', 'Gynecology'];

const PRODUCTS = [
  { icon: <FaBriefcaseMedical />, name: 'Surgical Scissors',     category: 'General Surgery', badge: 'Best Seller', desc: 'Precision-ground blades in straight, curved, and angled configurations for all surgical needs.', catalogRoute: '/catalogs/general-surgery' },
  { icon: <FaBone />,             name: 'Orthopedic Instruments', category: 'Orthopedic',      badge: 'New',         desc: 'Bone chisels, mallets, rasps, and retractors crafted from premium stainless steel.', catalogRoute: '/catalogs/orthopedic/hand' },
  { icon: <FaTooth />,            name: 'Dental Instruments',    category: 'Dental',           badge: null,          desc: 'Scalers, explorers, extraction forceps, and mirrors for complete dental procedures.', catalogRoute: '/catalogs/dental' },
  { icon: <FaEye />,              name: 'Ophthalmic Instruments', category: 'Ophthalmology',   badge: null,          desc: 'Delicate micro-instruments including iris scissors, needle holders, and specula.', catalogRoute: '/catalogs/complete' },
  { icon: <FaCut />,              name: 'Tissue Forceps',        category: 'General Surgery',  badge: 'Popular',     desc: 'Adson, rat-tooth, and dressing forceps with excellent grip and durability.', catalogRoute: '/catalogs/general-surgery' },
  { icon: <FaStethoscope />,      name: 'Diagnostic Instruments',category: 'ENT',              badge: null,          desc: 'Otoscopes, laryngoscopes, and nasal specula for accurate ENT diagnostics.', catalogRoute: '/catalogs/complete' },
  { icon: <FaSyringe />,          name: 'Gynecology Set',        category: 'Gynecology',       badge: null,          desc: 'Specula, curettes, dilators, and uterine sounds for obstetric procedures.', catalogRoute: '/catalogs/complete' },
  { icon: <FaHeartbeat />,        name: 'Retractors & Clamps',   category: 'General Surgery',  badge: 'Best Seller', desc: 'Self-retaining and hand-held retractors, hemostats, and clamps for open surgery.', catalogRoute: '/catalogs/general-surgery' },
];

export default function Products() {
  const [active, setActive] = useState('All');

  const visible = active === 'All'
    ? PRODUCTS
    : PRODUCTS.filter(p => p.category === active);

  return (
    <section className="products" id="products">
      <div className="container">
        <SectionTitle
          title="Our Product Range"
          subtitle="Over 500 high-quality surgical instruments manufactured to international standards"
        />

        <div className="products__filters" role="group" aria-label="Filter by category">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`products__filter-btn${active === cat ? ' products__filter-btn--active' : ''}`}
              onClick={() => setActive(cat)}
              aria-pressed={active === cat}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="products__grid">
          {visible.map(product => (
            <ProductCard key={product.name} {...product} />
          ))}
        </div>

        <div className="products__catalogs">
          <div>
            <h3>Browse Our Product Catalogs</h3>
            <p>
              Download detailed PDF catalogs for general surgery, dental, orthopedic hand
              instruments, locking plates, and our complete 1,300+ product range.
            </p>
          </div>
          <Button href="/catalogs" variant="primary">View All Catalogs</Button>
        </div>

        <div className="products__cta">
          <p>Can't find what you need? We manufacture custom instruments on request.</p>
          <Button href="/#contact" variant="primary">Contact for Custom Order</Button>
        </div>
      </div>
    </section>
  );
}
